import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { Bio } from '../../types/aboutBios';

interface BioCardProps {
    bio: Bio;
}

export default function BioCard({ bio }: BioCardProps) {
    const sanitizedBioText = useMemo(
        () => DOMPurify.sanitize(bio.bioText ?? ''),
        [bio.bioText]
    );

    const hasFooterLink = Boolean(bio.linkText?.trim() && bio.linkUrl?.trim());

    return (
        <article className="about-founder-card">
            <div className="about-founder-photo-wrap">
                {bio.imageUrl ? (
                    <img
                        src={bio.imageUrl}
                        alt={bio.title}
                        className="about-founder-photo"
                        width={120}
                        height={140}
                    />
                ) : (
                    <div className="about-founder-photo-placeholder" aria-hidden="true">
                        <span>{bio.title.charAt(0)}</span>
                    </div>
                )}
            </div>
            <div className="about-founder-info">
                {bio.position && (
                    <p className="about-founder-role">
                        <span className="about-section-label-diamond">◆</span> {bio.position}
                    </p>
                )}
                <h3 className="about-founder-name">{bio.title}</h3>
                {sanitizedBioText && (
                    <div
                        className="about-founder-bio about-founder-bio-html"
                        dangerouslySetInnerHTML={{ __html: sanitizedBioText }}
                    />
                )}
                {hasFooterLink && (
                    <p className="about-founder-link-line">
                        <a
                            href={bio.linkUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="about-founder-link"
                        >
                            {bio.linkText}
                        </a>
                    </p>
                )}
                {!hasFooterLink && bio.linkText?.trim() && (
                    <p className="about-founder-link-line">{bio.linkText}</p>
                )}
            </div>
        </article>
    );
}
